//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'HITFourTsScore',
  data () {
    return {
      form: {
        thrombopenia: '',
        plateletCountDrops: '',
        thrombosis: '',
        otherCauses: '',
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        {value: '2', name: '血小板计数下降＞50%（下降绝对值≥20*10⁹/L）'},
        {value: '1', name: '血小板计数下降30%~50%（下降绝对值10~19*10⁹/L）'},
        {value: '0', name: '血小板计数下降＜30%（下降绝对值＜10*10⁹/L）'}
      ],
      dataList2: [
        {value: '2', name: '5-10天内明确发病或血小板计数下降≤1天（30天内使用过肝素）。'},
        {value: '1', name: '5-10天内明确发病，但无血小板计数；超过10天后发病，或血小板计数下降≤1天（过去30-100天内使用过肝素）。'},
        {value: '0', name: '血小板计数下降＜4天，且未使用肝素。'}
      ],
      dataList3: [
        {value: '2', name: '新发血栓、皮肤坏死、静脉注射肝素后急性全身反应。'},
        {value: '1', name: '血栓进行性形成或再发、皮肤非坏死性病变、疑似血栓（未确诊）。'},
        {value: '0', name: '无'}
      ],
      dataList4: [
        {value: '2', name: '有明确病因'},
        {value: '1', name: '疑似病因'},
        {value: '0', name: '无可靠病因'}
      ],
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      let result = 0
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
        result += Number(form[key])
      }
      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        self.hasScore = true
        return String(result)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Hema/HITFourTsScore.vue